import { render } from "./UserSelectorButton.vue?vue&type=template&id=60de2716&ts=true"
import script from "./UserSelectorButton.vue?vue&type=script&lang=ts"
export * from "./UserSelectorButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__